export default __webpack_public_path__ + "static/media/olympPilot.1104e5c8.jpg";